import React from 'react';
import {getMessage} from '../utils/messages';
import type {ProjectTimeRecord} from '../types/types';

type MonthlyProjectTimeActionMenuProps = {
	entry: ProjectTimeRecord;
	isDisabled: boolean;
	canEdit: boolean;
	onStartEdit: (entry: ProjectTimeRecord) => void;
	onDeleteEntry: (entry: ProjectTimeRecord) => Promise<void>;
};

export const ContextMenu: React.FC<MonthlyProjectTimeActionMenuProps> = ({
																			 entry,
																			 isDisabled,
																			 canEdit,
																			 onStartEdit,
																			 onDeleteEntry,
																		 }) => (
	<div className="dropdown" style={{overflow: 'visible', position: 'relative'}}>
		<a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
			<i className="fal fa-bars"></i>
		</a>
		<ul className="dropdown-menu" style={{zIndex: 1}}>
			<li className={!canEdit || isDisabled ? 'disabled' : ''}>
				<a
					href="#"
					onClick={event => {
						event.preventDefault();
						if (!canEdit || isDisabled) {
							return;
						}
						onStartEdit(entry);
					}}
				>
					{getMessage('report.edit')}
				</a>
			</li>
			<li className={!canEdit || isDisabled ? 'disabled' : ''}>
				<a
					href="#"
					className="text-danger"
					onClick={event => {
						event.preventDefault();
						if (!canEdit || isDisabled) {
							return;
						}
						void onDeleteEntry(entry);
					}}
				>
					{getMessage('confirmation.delete')}
				</a>
			</li>
		</ul>
	</div>
);
